/*******************************************************************************
 * Project：
 * Summary:
 *　　 User Reducers
 * Remarks:
 *    Define Reducers for User
 * History：
 *    CuongLD            2021/05/31    Create
 ******************************************************************************/

import { EUserActions, UserActions } from './../actions/user.actions';
import { initialUserState, IUserState } from '../states/user.state';

export const userReducers = (
  state = initialUserState,
  action: UserActions
): IUserState => {
  switch (action.type) {
    case EUserActions.AddUser: {
      return {
        ...state,
        users: [...state.users, action.payload]
      };
    }
    default:
      return state;
  }
};
